/**
* Project - fasthelp5.fa2chat-product
*
* @desc チャット画面アプリケーション
*
* @author genka
* @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
*/
<template>
  <div id="FastchatApp">
    <fc-chat-starter ref="chatStarter" v-show="visibledChatStarter" @chatStart="chatStartHandler" @chatResume="chatResumeHandler" />
    <fc-chat-window ref="chatWindow" v-show="visibledChatWindow" @chatWindowClose="chatWindowCloseHandler" @chatWindowMinimize="chatWindowMinimizeHandler"
    @addNewFhMessage="addNewFhMessageHandler" @chatEnd="chatEndHandler" @myPageStartFailed="myPageStartFailedHandler" @mypageChatStart="chatStartHandler" @messageBotBackBefore="messageBotBeforeBackHandler"/>
  </div>
</template>

<script>
import WindowUtil from '@/utils/WindowUtil'
import FcChatStarter from '@/components/chatStarter/FcChatStarter'
import FcChatWindow from '@/components/chatWindow/FcChatWindow'
import DialogUtil from '@/utils/DialogUtil'
import FastchatStateManager from '@/utils/FastchatStateManager'
import ServiceUtil from '@/utils/ServiceUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import CommonConst from '@/constants/CommonConst'

export default {
  name: 'FastchatApp',
  components: {
    FcChatStarter,
    FcChatWindow
  },
  data() {
    return {
      /**
       * 「チャット開始」を表示するか
       * @type {Boolean}
       * @default true
       */
      visibledChatStarter: false,
      /**
       * チャット画面を表示するか
       * @type {Boolean}
       * @default false
       */
      visibledChatWindow: false
    }
  },
  mounted() {
    DialogUtil.App = this
    const mountedFunc = _ => {
      if (WindowUtil.isSeparateWindow()) {
        window.document.title = this.$t('チャットで質問する')
        WindowUtil.updateScreenMode('mobile')
        this.showChatWindow()
        this.$refs['chatWindow'].showFcChatEmptyPane()
        this.chatStartHandler()
      } else if (FastchatStateManager.isStarted() || FastchatStateManager.isSuspended() || FastchatStateManager.isSuspendedWithNewNoticed()) {
        if (WindowUtil.isMobileScreenMode() || this.$config['_alwaysSeparateChatWindow'] || FastchatStateManager.isAlwaysSeparateChatWindow()) {
          this.showChatStarter()
        } else {
          this.chatStartBySkipUserRegisterHandler()
        }
      } else {
        this.showChatStarter()
      }
    }
    if (this.$config['_myPageFlg'] === '1' && !this.$config['_nurofa2ak']) {
      // タイムアウトを設定
      this.$config['timeOut'] = setTimeout(_ => {
        DialogUtil.showInfoDialog(this.$extConfig['_retryMessage'], _ => {
          this.chatWindowCloseHandler()
        })
      }, this.$extConfig['_postMessageTimeoutSecond'] * 1000)
      console.log('info:timeoutNumber' + this.$config['timeOut'])
      console.log('info:timeoutSecond' + this.$extConfig['_postMessageTimeoutSecond'] * 1000)
    }
    const mypageAuthenticationFunc = (event) => {
      var fastchatUserInfo = {}
      if (!this.$config['_nurofa2ak']) {
        // タイムアウトを削除
        clearTimeout(this.$config['timeOut'])
        const key = event.data.customerInfoJson.key
        if (key) {
          console.log('info:マイページKeyチェック OK')
          fastchatUserInfo = {
            oneTimeKey: key
          }
          this.$config['oneTimeKey'] = key
        } else {
          console.log('info:マイページKeyチェック NG')
        }
      } else {
        fastchatUserInfo = {
          oneTimeKey: ''
        }
      }
      this.chatStartExecuteHandlerFromMyPage(fastchatUserInfo)
    }
    if (WindowUtil.isSeparateWindow()) {
      FastchatStateManager.setAlwaysSeparateChatWindow()
      mountedFunc()
    } else {
      WindowUtil.addMessageEventListener('alreadyFastchatFrame', mountedFunc, true)
    }
    // sendUserInfoAndStartChat処理
    WindowUtil.addMessageEventListener('sendUserInfoAndStartChat', mypageAuthenticationFunc, true)
  },
  methods: {
    /**
     * チャット開始を表示する
     */
    showChatStarter() {
      this.visibledChatStarter = true
      this.visibledChatWindow = false
      WindowUtil.postShowChatStarterMessageToParent()
    },
    /**
     * チャット画面を表示する
     */
    showChatWindow() {
      WindowUtil.postShowChatWindowMessageToParent()
      setTimeout(_ => {
        this.visibledChatStarter = false
        this.visibledChatWindow = true
      }, 0)
    },
    /**
     * チャット開始（サービス利用中ユーザー認証）イベントハンドラ
     */
    chatStartByUserCertificateHandler() {
      this.showChatWindow()
      this.$refs['chatWindow'].openUserCertificateHandler()
    },
    /**
     * チャット開始（ユーザー情報入力スキップ）イベントハンドラ
     */
    chatStartBySkipUserRegisterHandler(fastchatUserInfo) {
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatEmptyPane()
      this.$refs['chatWindow'].chatStart(fastchatUserInfo)
    },
    /**
     * チャット開始（マイページ）イベントハンドラ
     */
    chatStartByMypageHandler(fastchatUserInfo) {
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatMainPaneMypage()
      this.$refs['chatWindow'].chatStart(fastchatUserInfo)
    },
     /**
     * チャット開始（参照モードとBot応対をスキップ）イベントハンドラ
     */
    chatStartSkipReferMessageAndBotChatStartHandler(fastchatUserInfo) {
      this.$config['_distributionPrioritizeFlg'] = CommonConst.FLG_ON
      this.showChatWindow()
      fastchatUserInfo['userCertificateMode'] = '3'
      this.$refs['chatWindow'].showFcChatMainPaneMypage()
      setTimeout(_ => {
        this.$refs['chatWindow'].chatJoinHandler(fastchatUserInfo)
      }, 0)
    },
    /**
     * 参照処理ハンドラ
     */
    messageReferHandler(messageList) {
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatMainPaneMypageMessageRefer()
      this.$refs['chatWindow'].referMessagesStart(messageList)
    },
    /**
     * BOT前処理ハンドラ
     */
    messageBotBeforeHandler(responseData, fastchatUserInfo) {
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatMainPaneMypageMessageBot()
      this.$refs['chatWindow'].setBeforeMessageList(responseData.messages)
      this.$refs['chatWindow'].referMessagesStart(responseData.messages)
      this.$refs['chatWindow'].setUseBot()
      this.$refs['chatWindow'].setOneTimeKey(fastchatUserInfo.oneTimeKey)
      if (responseData.reconnectBot) {
         // BOT再開
         this.$refs['chatWindow'].chatBotReconnectHandler()
      }
    },
    /**
     * BOT前処理戻り用ハンドラ
     */
    messageBotBeforeBackHandler() {
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatMainPaneMypageMessageBot()
      this.$refs['chatWindow'].referMessagesStart(this.$refs['chatWindow'].beforeMessageList)
      this.$refs['chatWindow'].setUseBot()
      this.$refs['chatWindow'].setBeforeBotMessage()
      this.$refs['chatWindow'].receptionMode = null
      this.$refs['chatWindow'].lastScrollMessageList()
    },
    /**
     * チャット画面クローズイベントハンドラ
     */
    chatWindowCloseHandler() {
      if (WindowUtil.isSeparateWindow()) {
        window.close()
      } else {
        this.showChatStarter()
        this.$refs['chatStarter'].changeButtonToChatStart()
      }
    },
    /**
     * チャット画面最小化イベントハンドラ
     */
    chatWindowMinimizeHandler() {
      this.showChatStarter()
      this.$refs['chatStarter'].changeButtonToChatResume()
      this.$refs['chatWindow'].lastScrollMessageList()
    },
    /**
     * チャット再開イベントハンドラ
     */
    chatResumeHandler() {
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatMainPane()
      this.$refs['chatWindow'].scrollMessageListBySnsMessageId(FastchatStateManager.getLastNewFhMessageSnsMessageId())
    },
    /**
     * 新着メッセージイベントハンドラ
     */
    addNewFhMessageHandler() {
      if (this.visibledChatStarter && this.$refs['chatStarter'].buttonMode === 'resume') {
        FastchatStateManager.changeSuspendedWithNewNoticed()
        WindowUtil.postNoticeLabelMessageToParent(this.$t('新着メッセージあり'))
      }
    },
    /**
     * チャット開始イベントハンドラ
     * @return {[type]} [description]
     */
    chatStartHandler() {
      this.$config['_changeCertificateFlg'] = false
      if (this.$config['_myPageFlg'] === '1') {
        // window.openerが存在する、またはコンフィグにnurofa2akが存在する場合
        if (window.opener || this.$config['_nurofa2ak']) {
          this.$refs['chatWindow'].showLoading()
          if (this.$config['_nurofa2ak']) {
              // コンフィグにnurofa2akが存在する場合はマイページKey取得せずに、マイページ認証に進む
              this.mypageAuthenticationNurofa2ak()
          } else {
             // マイページ key 取得
             WindowUtil.getEmbeddedFastChatWindow().postMessage({
                type: 'requestUserInfo'
              }, '*')
              console.log('info:postMessage通知完了')
          }
        } else {
          setTimeout(_ => {
            DialogUtil.showInfoDialog(this.$extConfig['_retryMessage'], _ => {
              this.chatWindowCloseHandler()
            })
          }, 0)
        }
      } else {
        this.chatStartExecuteHandler()
      }
    },
    /**
     * チャット開始イベント実行ハンドラ
     * @return {[type]} [description]
     */
    chatStartExecuteHandler() {
      ServiceUtil.request('findFastchatServiceStatus', null, {
        start: _ => {
          this.$refs['chatStarter'].requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if ((!FastchatStateManager.isChatting() || this.$config['_changeCertificateFlg']) && responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            this.showChatWindow()
            this.$refs['chatWindow'].showFcChatEmptyPane()
            setTimeout(_ => {
              DialogUtil.showInfoDialog(responseData.message, _ => {
                this.chatWindowCloseHandler()
              })
            }, 0)
            return
          }
          // マイページ開始（マニュアル切り替えも含む）時に失敗していたら、サービス利用中ユーザー認証画面を表示する。
          if (this.$config['_changeCertificateFlg']) {
            this.chatStartByUserCertificateHandler()
            return
          }
          let skipUserRegister = false
          if (this.$config['restartOverSessionMode']) {
            skipUserRegister = responseData.logined || FastchatStateManager.isChatting()
          } else {
            skipUserRegister = responseData.logined || FastchatStateManager.existsFastchatState()
          }
          if (skipUserRegister) {
            this.chatStartBySkipUserRegisterHandler()
          } else {
            // サービス利用中ユーザー認証画面を表示する。
            this.chatStartByUserCertificateHandler()
          }
        },
        end: _ => {
          this.$refs['chatStarter'].requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * チャット開始イベント実行ハンドラ(マイページ用)
     * @return {[type]} [description]
     */
    chatStartExecuteHandlerFromMyPage(fastchatUserInfo) {
      ServiceUtil.request('findFastchatServiceStatusMypage', fastchatUserInfo, {
        start: _ => {
          this.$refs['chatStarter'].requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (!FastchatStateManager.isChatting() && responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            if (this.$config['_nuroChatAuthStatus'] !== '3') {
              this.showChatWindow()
              this.$refs['chatWindow'].showFcChatEmptyPane()
              setTimeout(_ => {
                DialogUtil.showInfoDialog(responseData.message, _ => {
                  this.chatWindowCloseHandler()
                })
              }, 0)
              return
            }
          }
          if (this.$refs['chatWindow'].getReferMode()) {
              this.switchChatStartOrMessageRefer(fastchatUserInfo)
          } else {
            this.chatStartMypage(fastchatUserInfo)
          }
        },
        end: _ => {
          this.$refs['chatStarter'].requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * チャット終了イベントハンドラ
     */
    chatEndHandler() {
      this.showChatWindow()
    },
    /**
     * SNSコール有無を判定して、チャット開始か、参照モードか処理を分岐します
     *
     * @param  {[Object]} fastchatUserInfo
     */
    switchChatStartOrMessageRefer(fastchatUserInfo) {
      var fastchatRequest = {
        oneTimeKey: fastchatUserInfo.oneTimeKey
      }
      if (fastchatUserInfo.nurofa2ak) {
        fastchatRequest.nurofa2ak = fastchatUserInfo.nurofa2ak
      }
      ServiceUtil.request('findSnsCallOpenInfoAndSnsMessages ', fastchatRequest, {
        start: _ => {
          this.requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (responseData.result === 'distributionPrioritize') {
            this.chatStartSkipReferMessageAndBotChatStartHandler(fastchatUserInfo)
          } else if (responseData.result === 'exist') {
            // SNSコールが既にある場合はチャット開始処理を実行
            this.chatStartMypage(fastchatUserInfo)
          } else if (responseData.result === 'notExist') {
            if (responseData.useBotFlg == null || responseData.useBotFlg === '0') {
              // コールがない場合は、アクセス時点での過去メッセージを表示
              DialogUtil.showConfirmDialog(this.$extConfig['_chatStartMessage'], _ => {
                this.messageReferHandler(responseData.messages)
              }, _ => {
                this.chatWindowCloseHandler()
              })
            } else {
              // BOTが有効になっているので、BOT開始ページを表示
              this.messageBotBeforeHandler(responseData, fastchatUserInfo)
            }
          } else {
            // 上記以外はマイページ認証失敗と判断して手動入力認証画面を表示
            this.myPageStartFailedHandler()
          }
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode)
        },
        end: _ => {
          this.$refs['chatWindow'].closeLoading()
          this.requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * チャット開始処理(マイページ)
     */
    chatStartMypage(fastchatUserInfo) {
      // ユーザー認証モードをセット
      this.$config['_nuroChatAuthStatus'] = '3'
      fastchatUserInfo['userCertificateMode'] = '3'
      // マイページ連携情報で顧客特定した上でチャット画面を表示する。
      ServiceUtil.request('findFastchatServiceStatusWithPreStartChatMyPage', {oneTimeKey: fastchatUserInfo.oneTimeKey}, {
        start: _ => {
          this.requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          this.chatStartByMypageHandler(fastchatUserInfo)
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode)
        },
        end: _ => {
          this.requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * マイページ開始失敗イベントハンドラ
     */
    myPageStartFailedHandler() {
      // ログを出して、通常の認証画面実行ロジックへ
      console.log('info:マイページ開始失敗のため、通常の認証画面を表示します。 oneTimeKey:' + this.$config['oneTimeKey'])
      this.$config['_nuroChatAuthStatus'] = '4'
      this.$config['_mypageApiResultInfo'] = null
      DialogUtil.showInfoDialog(this.$extConfig['_sorryMessage'], _ => { })
      this.$config['_changeCertificateFlg'] = true
      this.chatStartExecuteHandler()
    },
    /**
      * Nurofa2ak有りのマイページ認証
      */
    mypageAuthenticationNurofa2ak() {
        var fastchatUserInfo = {
          nurofa2ak: this.$config['_nurofa2ak']
        }
        this.chatStartExecuteHandlerFromMyPage(fastchatUserInfo)
        if (WindowUtil.isSeparateWindow()) {
            FastchatStateManager.setAlwaysSeparateChatWindow()
        }
    }
  }
}
</script>

<style>
html,
#FastchatApp {
  height: 100%;
  overflow: hidden;
  font-family: 游ゴシック体, 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', Meiryo, メイリオ, Osaka, 'MS PGothic', arial, helvetica, sans-serif;
  border-radius: 5px;
}

body {
  height: 100%;
  margin: 0;
  padding: 0 !important;
}

main {
  display: block;
}

div.el-message-box {
  width: 300px;
}

div.el-message-box p {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue